<template>
  <div id="contenedor-main-auditoria">
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: 'MainAuditoria',
};
</script>
